import { KEYWORD_TRIGGERED_BANNER_ERROR } from "./const";

function action() {
  return {
    type: KEYWORD_TRIGGERED_BANNER_ERROR,
  };
}

export default action;
